import React from "react";
import { Card, CardContent } from "@/components/ui/card";

const Help: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold">Help & Support</h1>
      </div>

      <iframe
        id="JotFormIFrame-251801202496350"
        title="Tastermonial Lab Support Form"
        onLoad={() => window.parent.scrollTo(0,0)}
        allowTransparency={true}
        allow="geolocation; microphone; camera; fullscreen; payment"
        src="https://form.jotform.com/251801202496350"
        style={{
          width: "100vw",
          height: "calc(100vh - 200px)",
          border: "none",
          marginLeft: "calc(-50vw + 50%)",
          marginRight: "calc(-50vw + 50%)"
        }}
        className="w-full"
      ></iframe>
      <script src="https://cdn.jotfor.ms/s/umd/latest/for-form-embed-handler.js"></script>
      <script>
        window.jotformEmbedHandler("iframe[id='JotFormIFrame-251801202496350']",
        "https://form.jotform.com/")
      </script>
    </div>
  );
};

export default Help;
